import { LoggedUser } from "../../../redux/store";
import { Account } from "@idha/idha-types";
import * as R from "ramda";
import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import { hasRole } from "redux/helperFunctions/loggedUser.helperFunctions";

export class TagsAccessPermissions extends ModulePermissions{
    tagsModuleUser:boolean = true;

    constructor(){
        super();
    }
}

export class TagsPermissionsPipeData extends PermissionsPipeData<TagsAccessPermissions>{    
    constructor(loggedUser: LoggedUser) {
        super(loggedUser,new TagsAccessPermissions());
    }
}

namespace AccessRules {  
    export function notTagUser(data: TagsPermissionsPipeData):TagsPermissionsPipeData{
        if(hasRole(data.loggedUser,'admin')) return data;

        if(!hasRole(data.loggedUser,'tags.tagsUser')){
            data.permissions.tagsModuleUser = false;
        }

        return data;
    }

    export function end(data: TagsPermissionsPipeData):TagsAccessPermissions{
        return data.permissions
    }
}


export default R.pipe(
    AccessRules.notTagUser,
    AccessRules.end
);





